import { ADDRESS_TEXT_MAX_LENGTH } from '~/lib/geo-providers/ADDRESS_TEXT_MAX_LENGTH'

/** True when typed address text exceeds the search `q` limit. */
export function isOverlongAddressText(text: string): boolean {
  return text.trim().length > ADDRESS_TEXT_MAX_LENGTH
}
